<template>
  <div class="about">
    <Card style="">
      <p slot="title">
        <Icon type="ios-cart"></Icon>
        收货货查询
      </p>
      <div>
        <Row>
          <Col span="10">
            <Form :model="formItem" :label-width="80">
              <FormItem label="选择日期">
                <Row>
                  <Col span="10">
                    <DatePicker type="date" placeholder="Select date" v-model="formItem.startDate" style="width: 100%"></DatePicker>
                  </Col>
                  <Col span="2" style="text-align: center">-</Col>
                  <Col span="10">
                    <DatePicker type="date" placeholder="Select time" v-model="formItem.endDate" style="width: 100%"></DatePicker>
                  </Col>
                  <Col span="2" style="text-align: center">
                    <Button type="primary" @click="getData">查询</Button>
                  </Col>
                </Row>
              </FormItem>
            </Form>
          </Col>
        </Row>
        <Table :columns="dataColumns" border  :data="tableData"  height="600"></Table>
      </div>
    </Card>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        formItem: {
          startDate: '',
          endDate: '',
        },
        dataColumns: [
          {   
            title: "序号",
            type: "index",
            width: 60,
            align: 'center'
          },
          {
            title: '设备 ID',
            key: 'deviceCode'
          },
          {
            title: '机台编号',
            key: 'product_no'
          },
          {
            title: '机台名称',
            key: 'product_name'
          },
          {
            title: '出厂日期',
            key: 'createdTime'
          },
          {
            title: "机台参数",
            key: "spec"
          }
        ],
        tableData: [
         
        ]
      }
    },
    watch: {
      
    },
    methods:{
      getData(){
        let data = this.formItem
        data.startDate = new Date(data.startDate).Format("yyyy-MM-dd")
        data.endDate = new Date(data.endDate).Format("yyyy-MM-dd")
        this.$http.postDataWhitToken(this, "/ewlMerchant/deviceReceiveQuery", this.formItem).then( res => {
          console.log(res)
          let records = res.records
          let tableData = []
          for (let i = 0; i < records.length; i++) {
            records[i]['product_no'] = records[i].params['product_no']
            records[i]['product_name'] = records[i].params['product_name']
            records[i]['spec'] = records[i].params['spec']
          }
          this.tableData = records
        }).catch(err => {
          console.log(err)
        })
      }
    },
    created() {
      this.$set(this.formItem, "startDate", new Date().Format("yyyy-MM-dd"))
      this.$set(this.formItem, "endDate", new Date().Format("yyyy-MM-dd"))
      this.getData()
    }
  }
</script>